import React from 'react';
import { Button, Form, Grid, Input, Segment, TextArea } from 'semantic-ui-react';
import { DateTimePicker } from 'react-widgets';
import moment from 'moment';
import axios from 'axios';
import { toast } from 'react-toastify';

export default class EditStudentMobilityInternship extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            internship: this.props.internship,
            institution: this.props.internship.institutionName,
            institutionEn: this.props.internship.translations.filter((e) => e.language === 'en')[0] ? this.props.internship.translations.filter((e) => e.language === 'en')[0].institutionName : null,
            institutionOther: this.props.internship.translations.filter((e) => e.language !== 'en')[0] ? this.props.internship.translations.filter((e) => e.language !== 'en')[0].institutionName : this.props.internship.translations.filter((e) => e.language === 'en' && JSON.parse(localStorage.getItem('mob')).translations.find((f) => f.originalLanguage === true && f.language === 'en'))[0] ? this.props.internship.translations.filter((e) => e.language === 'en' && JSON.parse(localStorage.getItem('mob')).translations.find((f) => f.originalLanguage === true && f.language === 'en'))[0].institutionName : null,
            // institutionOther: this.props.internship.translations.filter((e) => e.language !== 'en')[0] ? this.props.internship.translations.filter((e) => e.language !== 'en')[0].institutionName : null,
            startDate: moment(this.props.internship.dateStart).format('D. M. YYYY.'),
            newDate: new Date(this.props.internship.dateStart),
            endDate: moment(this.props.internship.dateEnd).format('D. M. YYYY.'),
            newEndDate: new Date(this.props.internship.dateEnd),
            description: this.props.internship.description,
            comment: this.props.internship.comment,
            otherLang: JSON.parse(localStorage.getItem('mob')).translations.filter((e) => e.originalLanguage === true)[0] ? JSON.parse(localStorage.getItem('mob')).translations.filter((e) => e.originalLanguage === true)[0].language : null,
            // otherLang: this.props.internship.translations.filter((e) => e.language !== 'en')[0] ? this.props.internship.translations.filter((e) => e.language !== 'en')[0].language : null,
            otherLangOptions: [],

            institutionErr: false,
            institutionEnErr: false,
            institutionOtherErr: false,
            startDateErr: false,
            endDateErr: false,
            descriptionErr: false,
            commentErr: false,
            otherLangErr: false
        };
        this.handleDateChange = this.handleDateChange.bind(this);
        this.fetchLangOptions = this.fetchLangOptions.bind(this);
        this.closeEditMode = this.closeEditMode.bind(this);
        this.editInternship = this.editInternship.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        this.fetchLangOptions();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.internship !== this.state.internship) {
            this.fetchLangOptions();
            this.setState({
                internship: this.props.internship,
                institution: this.props.internship.institutionName,
                institutionEn: this.props.internship.translations.filter((e) => e.language === 'en')[0] ? this.props.internship.translations.filter((e) => e.language === 'en')[0].institutionName : null,
                institutionOther: this.props.internship.translations.filter((e) => e.language !== 'en')[0] ? this.props.internship.translations.filter((e) => e.language !== 'en')[0].institutionName : this.props.internship.translations.filter((e) => e.language === 'en' && JSON.parse(localStorage.getItem('mob')).translations.find((f) => f.originalLanguage === true && f.language === 'en'))[0] ? this.props.internship.translations.filter((e) => e.language === 'en' && JSON.parse(localStorage.getItem('mob')).translations.find((f) => f.originalLanguage === true && f.language === 'en'))[0].institutionName : null,
                // institutionOther: this.props.internship.translations.filter((e) => e.language !== 'en')[0] ? this.props.internship.translations.filter((e) => e.language !== 'en')[0].institutionName : null,
                startDate: moment(this.props.internship.dateStart).format('D. M. YYYY.'),
                newDate: new Date(this.props.internship.dateStart),
                endDate: moment(this.props.internship.dateEnd).format('D. M. YYYY.'),
                newEndDate: new Date(this.props.internship.dateEnd),
                description: this.props.internship.description,
                comment: this.props.internship.comment,
                otherLang: JSON.parse(localStorage.getItem('mob')).translations.filter((e) => e.originalLanguage === true)[0] ? JSON.parse(localStorage.getItem('mob')).translations.filter((e) => e.originalLanguage === true)[0].language : null,
                // otherLang: this.props.internship.translations.filter((e) => e.language !== 'en')[0] ? this.props.internship.translations.filter((e) => e.language !== 'en')[0].language : null,
                otherLangOptions: [],
            });
        }
    }

    fetchLangOptions() {
        axios.get('/languages')
            .then(res => {
                this.setState({
                    otherLangOptions: res.data.map(el => ({
                        key: el.twoLetterCode,
                        value: el.twoLetterCode,
                        text: el.name
                    }))
                });
            });
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    closeEditMode() {
        this.props.closeEditMode();
    }
    editInternship(
        institution,
        newDate,
        newEndDate,
        description,
        comment
    ) {
        if (!this.state.institution || !this.state.startDate || !this.state.endDate ||
        (!this.state.institutionEn && !this.state.institutionOther && !this.state.otherLang)
        || (this.state.institutionEn && this.state.institutionOther && !this.state.otherLang)
        || (!this.state.institutionEn && this.state.institutionOther && !this.state.otherLang)
            || (!this.state.institutionEn && !this.state.institutionOther && this.state.otherLang)) {
            if (!this.state.institutionEn && !this.state.institutionOther) {
                toast('Niste unijeli sve podatke. Unesite barem jedan prevod za instituciju.');
            } else { toast('Niste unijeli sve podatke.'); }
            if (!this.state.institution) { this.setState({ institutionErr: true }); } else { this.setState({ institutionErr: false }); }
            if (!this.state.startDate) { this.setState({ startDateErr: true }); } else { this.setState({ startDateErr: false }); }
            if (!this.state.endDate) { this.setState({ endDateErr: true }); } else { this.setState({ endDateErr: false }); }
            if (!this.state.institutionEn && !this.state.institutionOther && !this.state.otherLang) { this.setState({ institutionEnErr: true, institutionOtherErr: true, otherLangErr: true }); } else { this.setState({ institutionEnErr: false, institutionOtherErr: false, otherLangErr: false }); }
            if (!this.state.institutionEn && !this.state.institutionOther && this.state.otherLang) { this.setState({ institutionOtherErr: true, }); }
            if (!this.state.institutionEn && this.state.institutionOther && !this.state.otherLang) { this.setState({ otherLangErr: true }); }
            if (this.state.institutionOther && !this.state.otherLang) { this.setState({ otherLangErr: true }); }
            if (!this.state.institutionOther && this.state.otherLang) { this.setState({ institutionOtherErr: true }); }
        } else {
            let optLock = this.props.internship.optLock;
            let id = this.props.internship.id;
            let translations = [];
            if (this.state.institutionEn && this.state.otherLang !== 'en') {
                translations.push({
                    language: { twoLetterCode: (this.state.otherLangOptions.filter((e) => e.value === 'en') ? this.state.otherLangOptions.find((e) => e.value === 'en').value : null) },
                    // language: { twoLetterCode: 'en' },
                    institutionName: this.state.institutionEn
                });
            }
            if (this.state.institutionOther) {
                translations.push({
                    language: { twoLetterCode: this.state.otherLang },
                    institutionName: this.state.institutionOther
                });
            }

            let createMarkObj = {
                institutionName: this.state.institution,
                optLock,
                id,
                description: this.state.description,
                dateStart: this.state.newDate,
                dateEnd: this.state.newEndDate,
                comment: this.state.comment,
                translations: [...translations]

            };

            axios.put('student-mobility-internship/edit/', { ...createMarkObj })
                .then(res => {
                    toast('Izmjena prakse je uspješno izvršena.');
                    this.props.getMobilityInternship();
                    this.props.closeEditMode();
                })
                .catch(err => {
                    toast('Došlo je do greške! Izmjena prakse nije uspjela.');
                });
        }
    }

    render() {
        return (<div>
            <Segment.Group secondary>
                <Segment secondary clearing>
                    <Form noValidate>
                        <Grid columns={2} centered className="stackable">
                            <Grid.Row stretched>
                                <Grid.Column>
                                    <Form.Field
                                        required
                                        control={Input}
                                        label="Institucija (B/H/S)"
                                        value={this.state.institution}
                                        onChange={(e) => this.setState({ institution: e.target.value })}
                                        name="institution"
                                        placeholder="Unesite naziv predmeta"
                                        error={this.state.institutionErr}
                                    />
                                    <Form.Field
                                        required
                                        control={Input}
                                        label="Institucija (engleski jezik)"
                                        value={this.state.institutionEn}
                                        onChange={(e) => this.setState({ institutionEn: e.target.value })}
                                        name="institutionEn"
                                        placeholder="Unesite naziv institucije"
                                        error={this.state.institutionEnErr}
                                        disabled={this.state.otherLang === 'en'}
                                    />
                                </Grid.Column>
                                <Grid.Column>
                                    <Segment>
                                        <Form.Field error={this.state.otherLangErr}>
                                            <label>Izvorni jezik</label>
                                            <Form.Dropdown
                                                clearable
                                                selection
                                                placeholder="Odaberite izvorni jezik"
                                                value={this.state.otherLang}
                                                onChange={this.handleInputChange}
                                                name="otherLang"
                                                options={this.state.otherLangOptions.filter((e) => (e.value !== 'bs'))}
                                                search
                                                fluid
                                            />
                                        </Form.Field>
                                        <Form.Field
                                            control={Input}
                                            label="Institucija (izvorni jezik)"
                                            value={this.state.institutionOther}
                                            onChange={(e) => this.setState({ institutionOther: e.target.value })}
                                            name="institutionOther"
                                            placeholder="Unesite naziv institucije"
                                            error={this.state.institutionOtherErr}
                                        />
                                    </Segment>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        <Grid columns={2} centered className="stackable">
                            <Grid.Row stretched>
                                <Grid.Column>
                                    <Grid.Column>
                                        <Form.Field
                                            required
                                            control={DateTimePicker}
                                            label="Datum početka"
                                            format="D. M. YYYY."
                                            placeholder="Unesite datum početka prakse"
                                            value={this.state.newDate}
                                            time={false}
                                            onChange={this.handleDateChange.bind(null, 'newDate')}
                                            style={{ borderWidth: '0px' }}
                                            error={this.state.startDateErr}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Form.Field
                                            required
                                            control={DateTimePicker}
                                            label="Datum kraja"
                                            format="D. M. YYYY."
                                            placeholder="Unesite datum kraja prakse"
                                            value={this.state.newEndDate}
                                            time={false}
                                            onChange={this.handleDateChange.bind(null, 'newEndDate')}
                                            style={{ borderWidth: '0px' }}
                                            error={this.state.endDateErr}
                                        />
                                    </Grid.Column>
                                </Grid.Column>
                                <Grid.Column>
                                    <Form.Field
                                        label="Opis"
                                        control={TextArea}
                                        name="description"
                                        rows={6}
                                        value={this.state.description}
                                        onChange={this.handleInputChange}
                                        placeholder="Unesite opis..."
                                    />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        <Grid columns={1} centered className="stackable">
                            <Grid.Row stretched>
                                <Grid.Column>
                                    <Form.Field
                                        label="Komentar"
                                        control={TextArea}
                                        name="comment"
                                        rows={1}
                                        value={this.state.comment}
                                        onChange={this.handleInputChange}
                                        placeholder="Unesite komentar..."
                                    />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        <br />
                        <Button color="blue" basic="true" floated="right" onClick={this.closeEditMode}>Odustani</Button>
                        <Button
                            color="blue"
                            floated="right"
                            onClick={() => this.editInternship(
                                this.state.institution,
                                this.state.newDate,
                                this.state.newEndDate,
                                this.state.description,
                                this.state.comment,
                            )}
                        >
                            Sačuvaj izmjene
                        </Button>
                    </Form>
                </Segment>
            </Segment.Group>
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/EditStudentMobilityInternship.js